<template>
    <div class="alert alert-secondary">
        <div class="discrim-text">
            Federal rules prohibit cafeteria plans (aka "POP plans") from providing offering
            benefits in a manner that discriminates in favor of highly-compensated employees
            (often called "HCEs") or provides more than 25% of the total benefits under the
            plan to so-called "Key Employees" (often just called "Keys").<br>
            <br>
            The purpose of these rules is to ensure that employees at all levels enjoy the benefits
            offered through an employer's cafeteria plan, rather than just managers, executives
            and other upper-tier employees.
            <br>
            <br>
            A Highly Compensated Employee (<em>HCE</em>) is any of the following:<br>
            <ul>
                <li>An officer of the employer or</li>
                <li>
                    A person owning more than 5% of the employer entity at any point during the current
                    or preceding plan year or
                </li>
                <li>{{ hce }}</li>
                <li>A spouse or tax dependent of any of the above individuals, who is also employed by the company</li>
            </ul>


            A <em>Key Employee</em> is any of the following:
            <br>
            <ul>
                <li>{{ keyEmployee }}</li>
                <li>A person with ownership of more-than-5% of the employer entity* or</li>
                <li>
                    A person with ownership of more than 1% of the employer entity* with an annual compensation
                    over $150,000.
                </li>
            </ul>
            <em>
                *Please note that certain "ownership attribution" rules apply for determining business
                ownership with regard to family members. Generally, an individual is deemed to own
                the interest held by his or her spouse (other than one who is legally separated),
                children, grandchildren, and parents.
            </em>
            <br>
            <br>
            There are three basic components to the testing of cafeteria plans.<br>
            <br>
            The <strong>Eligibility Test</strong> determines whether the plan is broadly offered
            to non-HCEs along with HCEs. In general, all employees of the plan sponsor and any
            other business that is a member of a related group of businesses must be included
            in the testing group for the Eligibility Test. If you are able to answer "yes" to all
            questions on this portion of the test, your plan automatically passes the non-descrimination
            test; you will not be prompted to answer any further questions.<br>
            <br>
            The <strong>Contributions and Benefits Test</strong> determines whether plan benefits
            are available to non-HCEs on the same or similar terms as HCEs. All employees who
            are eligible to participate in the plan should be included for this test.
            <br>
            <br>
            As its name implies, the <strong>Key Employee Concentration Test</strong> has to
            do with Key Employees rather than HCEs. This test determines whether such Key Employees
            receive more than 25% of the total benefits under the plan. For this test, only
            plan participants who have elected nontaxable benefits are including in the testing
            group.
            <br>
            <br>
            Before going further, please make sure that you have the following items and other
            pieces of information available. All of the following will be necessary for completion
            of the discrimination testing regimen:<br>
            <ol>
                <li>Your existing plan document.</li>
                <li>The number of non-HCEs eligible to participate in the cafeteria plan. </li>
                <li><strong>Total</strong> number of non-HCEs</li>
                <li>Number of HCEs eligible to participate in the cafeteria plan. </li>
                <li><strong>Total</strong> number of HCEs</li>
                <li>
                    Total dollar amount of pre-tax premiums (paid by both the employer AND the employee) for ALL employees
                    participating in the cafeteria plan
                </li>
                <li>
                    Total dollar amount of pre-tax premiums (paid by both the employer AND the employee) for Key Employees
                    participating in the cafeteria plan
                </li>
            </ol>
            <p align="center">
            </p>
            <div style="text-align: center; font-weight: bold;">
                If you need help, please view our Non-Discrimination Testing walkthrough video <a href="https://s3.amazonaws.com/myameriflex-videos/Non+Discrimination+Testing+Tutorial.mp4" target="_blank">HERE</a>
            </div>
            <p>
            </p>
        </div>
        <br/>
        <input type="button" class="btn btn-primary" @click.prevent="next" value="Next" />
    </div>
</template>

<script>
    import { config } from './helpers'

    export default {
        computed: {
            hce: () => config.hce,
            keyEmployee: () => config.keyEmployee
        },
        methods: {
            next() {
                this.$emit('next', { nextComponent: 'step1' });
            }
        }
    }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/shared/Nondiscrimination/POP/Instructions.vue